module.exports = __webpack_public_path__ + "static/media/futo_logo.4845d2e4.png";